"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vocabularyWordIndexKey = exports.vocabularyWordKey = exports.WordClass = void 0;
var WordClass;
(function (WordClass) {
    WordClass["noun"] = "noun";
    WordClass["verb"] = "verb";
    WordClass["adjective"] = "adjective";
    WordClass["adverb"] = "adverb";
})(WordClass = exports.WordClass || (exports.WordClass = {}));
const WORD_SORT_KEY = 'word';
const vocabularyWordKey = (wordId) => ({
    wordId,
    sk: WORD_SORT_KEY
});
exports.vocabularyWordKey = vocabularyWordKey;
const vocabularyWordIndexKey = ({ wordId, word }) => ({
    wordId,
    word,
    sk: WORD_SORT_KEY
});
exports.vocabularyWordIndexKey = vocabularyWordIndexKey;
//# sourceMappingURL=VocabularyWord.js.map